var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"section",staticClass:"section-segment",attrs:{"id":_vm.sectionReference}},_vm._l((_vm.segmentData.segments),function(segment){return _c(segment.type + '-segment',{key:segment.id,tag:"component",attrs:{"segment-data":segment.data,"id":segment.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }